import { render, staticRenderFns } from "./Check_orglist.vue?vue&type=template&id=59cb0a60"
import script from "./Check_orglist.vue?vue&type=script&lang=js"
export * from "./Check_orglist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports